import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useRef, useEffect } from 'react';
import GradientBackground from './components/GradientBackground';
import Nav from './components/Nav';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import NurseryPage from './pages/NurseryPage';
import PortfolioPage from './pages/PortfolioPage';
import VisionPage from './pages/VisionPage';
import AboutPage from './pages/AboutPage';
import AboutElaPage from './pages/AboutElaPage';
import ContactPage from './pages/ContactPage';
import AdminPage from './pages/AdminPage';
import SubmitIdeaPage from './pages/SumbitIdeaPage';

import { init } from '@plausible-analytics/tracker'

export default function App() {
    const plausibleInitialized = useRef(false);

    useEffect(() => {
        if (plausibleInitialized.current) return;
        plausibleInitialized.current = true;

        init({
            domain: window.location.hostname,
            formSubmissions: true,
            outboundLinks: true,
            fileDownloads: true,
        });
    }, []);

    return (
        <BrowserRouter>
            <ScrollToTop />
            <GradientBackground />
            <Nav />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/nursery" element={<NurseryPage />} />
                <Route path="/portfolio" element={<PortfolioPage />} />
                <Route path="/submit-idea" element={<SubmitIdeaPage />} />
                <Route path="/vision" element={<VisionPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/about-ela" element={<AboutElaPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin" element={<AdminPage />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
}
